const content = {
  title: "Nuance, Tone & Formality",
  explanation: `
At C1 level, effective communication depends on deliberate control of tone, register, and interpersonal stance.
Example: Send me the file. / Could you please forward the file at your convenience?

Formality is shaped largely by lexical choice, sentence framing, and degree of directness.
Example: We reject your request. / We regret to inform you that your request cannot be approved.

Hedging and diplomatic phrasing help express caution, disagreement, or uncertainty professionally.
Example: The findings seem to suggest a possible reporting bias.

The objective is context-sensitive expression: clear, respectful, and precise in academic or professional settings.
Example: While I appreciate your perspective, I would argue that the current evidence is insufficient.
  `,
  rules: [
    "Formal language often avoids contractions (do not, cannot)",
    "Word choice directly affects tone (ask → request → inquire)",
    "Indirect language usually sounds more polite and diplomatic",
    "Hedging expressions soften statements (seems, appears, tends to)",
    "Formal writing prefers neutral or impersonal structures",
    "Tone should always match the context (email, report, presentation, discussion)"
  ],
  examples: [
    "Could you possibly assist me with this matter? (formal request)",
    "It appears that the results were influenced by external factors. (hedging)",
    "I would appreciate your feedback on this issue at your convenience.",
    "The proposal seems to require further discussion before approval.",
    "We regret to inform you that your request has been declined.",
    "I disagree with this approach, although I understand its advantages. (polite disagreement)"
  ]
};

export default content;


